import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";


export default class GoogleDriveAttach extends BaseComponent {
    static propTypes = {
        organizationId: PropTypes.string,
        attachments: PropTypes.array,
        onChange: PropTypes.func
    };

    constructor(props) {
        super(props);

        // currently gd.session.modules is not available in sgared view
        const modules = gd.session.modules.get(this.props.organizationId)

        this.state = {
            driveConnected  : modules && !!modules.gDrive,
            attachments     : this.props.attachments ? this.props.attachments : []
        }
    }

    updateAttachments = () => {
        this.setState({
            attachments: this.props.attachments ? this.props.attachments : []
        });
    }

    onAttachFiles = (files) => {
        this.setAttachedFilesPermissions(files);

        this.setState({
            attachments: files
        }, ()=>{
            if (this.props.onChange) this.props.onChange(files)
        });
    };

    setAttachedFilesPermissions = (files, onDoneCallback) => {
        const { organizationId } = this.props;

        // build list of commands
        const serialActions = [];
        files && files.map(file=>{
            if(file.storageProvider === gd.const.storageProvider.GOOGLE_DRIVE)
                serialActions.push({action: "setPermission", id: file.fileId})
        });

        const sequenceAction = (pos, addNextCall)=>{
            const sa = serialActions[pos];
            let request;
            if (sa) {
                request = ApiIntegrationRequest.POST(this,'gdrive/set_public/'+organizationId, {
                    file_id: sa.id
                });

                request.done(data=>{addNextCall(++pos)});
                request.fail(error=>{
                    gd.apiError(error);
                    addNextCall(++pos);
                });
            } else {
                if (onDoneCallback) onDoneCallback(null);
            }
        };

        const serialMove = (pos=0)=>{sequenceAction(pos, serialMove);};
        serialMove();
    };

    onClick = () => {
        const { driveConnected } = this.state;
        if (!driveConnected) return;

        gd.modals.integration.googleDrive({
            attachments: this.state.attachments,
            organizationId: this.props.organizationId,
            type: "attachFile",
            onAttachFiles: this.onAttachFiles
        });
    };

    render() {
        const { driveConnected } = this.state;
        return driveConnected ? (
            <div className="google-drive-attach-container" onClick={this.onClick}>
                <div className="i5-gdrive google-drive-attach-icon"> </div>
                <div className="label">GoogleDrive</div>
            </div>
        ) : <span/>;
    }
}
